import { AxiosError } from 'axios';
import { put, call, takeLatest, select } from 'redux-saga/effects';
import { API } from '../api/base';
import { types, LogEventRequest, GetEventsResponse } from './types';
import { selectors as kioskSelectors, Kiosk } from 'services/kiosk';
import { selectors as authSelectors } from 'services/auth';
import { getErrorMessage } from 'services/api/normalizer';

export function* getKioskEventsAsync() {
  const { id }: Kiosk = yield select(kioskSelectors.selectKiosk);
  const eventApi = new API(`kiosks/${id}/events`);

  yield put({ type: types.GET_EVENTS_ASYNC.PENDING, payload: true });

  try {
    const response: GetEventsResponse = yield call(eventApi.getAll, { data: { role: 'ClientAdmin' } });
    yield put({ type: types.GET_EVENTS_ASYNC.SUCCESS, payload: response });
  } catch (err) {
    const message = getErrorMessage(err as AxiosError);
    yield put({ type: types.GET_EVENTS_ASYNC.ERROR, payload: message });
  } finally {
    yield put({ type: types.GET_EVENTS_ASYNC.PENDING, payload: false });
  }
}

export function* getLatestKioskEventsAsync() {
  const { id }: Kiosk = yield select(kioskSelectors.selectKiosk);
  const eventApi = new API(`kiosks/${id}/events/latest`);

  yield put({ type: types.GET_LATEST_EVENTS_ASYNC.PENDING, payload: true });

  try {
    const response: GetEventsResponse = yield call(eventApi.getAll);
    yield put({ type: types.GET_LATEST_EVENTS_ASYNC.SUCCESS, payload: response });
  } catch (err) {
    const message = getErrorMessage(err as AxiosError);
    yield put({ type: types.GET_LATEST_EVENTS_ASYNC.ERROR, payload: message });
  } finally {
    yield put({ type: types.GET_LATEST_EVENTS_ASYNC.PENDING, payload: false });
  }
}

export function* logKioskEventAsync({ payload }: LogEventRequest) {
  const { id }: Kiosk = yield select(kioskSelectors.selectKiosk);
  const adminId: string = yield select(authSelectors.selectAdminId);
  const maintenanceId: string = yield select(authSelectors.selectMaintenanceId);
  const { includeActor, ...eventPayload } = payload;
  if (includeActor) {
    eventPayload.actorId = maintenanceId || adminId;
  }

  const url = payload.kioskHardwareId ? 'hardware/events' : 'events';
  const eventApi = new API(`kiosks/${id}/${url}`);

  yield put({ type: types.LOG_EVENT_ASYNC.PENDING, payload: true });

  try {
    yield call(eventApi.create, eventPayload);
    yield put({ type: types.LOG_EVENT_ASYNC.SUCCESS });
  } catch (err) {
    const message = getErrorMessage(err as AxiosError);
    yield put({ type: types.LOG_EVENT_ASYNC.ERROR, payload: message });
  } finally {
    yield put({ type: types.LOG_EVENT_ASYNC.PENDING, payload: false });
  }
}

export const sagas = [
  takeLatest(types.LOG_EVENT_ASYNC.REQUEST, logKioskEventAsync),
  takeLatest([types.GET_LATEST_EVENTS_ASYNC.REQUEST, types.LOG_EVENT_ASYNC.SUCCESS], getLatestKioskEventsAsync)
];
